import { InitOverrideFunction, SystemPromptApi, SystemPromptItemDto, SystemPromptPutRequest } from "../../../@api";

export class SystemPromptApiService
  implements Omit<SystemPromptApi, `${string}Raw` | "withMiddleware" | "withPreMiddleware" | "withPostMiddleware">
{
  constructor(private readonly api: SystemPromptApi) {}

  deleteSystemPrompt(initOverrides?: RequestInit | InitOverrideFunction): Promise<string> {
    return this.api.deleteSystemPrompt(initOverrides);
  }

  systemPromptGet(initOverrides?: RequestInit | InitOverrideFunction): Promise<SystemPromptItemDto> {
    return this.api.systemPromptGet(initOverrides);
  }

  systemPromptPut(
    requestParameters: SystemPromptPutRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<SystemPromptItemDto> {
    return this.api.systemPromptPut(requestParameters, initOverrides);
  }
}
